export const REACT_APP_STAGE = "production";
export const REACT_APP_GROWSARI_GRAPHQL_URI = "https://z9f5u8qp77.execute-api.ap-southeast-1.amazonaws.com/prd/graphql";
export const REACT_APP_TRANSACTION_HISTORY_BASE_URL = "https://history.growsari.com/user/v1/";
export const REACT_APP_CREDIT_BASE_URL = "https://growcredit.growsari.com/api/v2/";
export const REACT_APP_KONEKBUHAY_BASE_URL = "https://konekbuhay.com";
export const REACT_APP_GS_DEFAULT_MERCHANT_ID = "566b1b81-2328-4e0f-ab1d-fdcb2485a33b";
export const REACT_APP_SIGNUP_LOCALITY = "https://admin.growsari.com/api/";
export const REACT_APP_META_PIXEL_ID = "621802908538307";
export const REACT_APP_FULLSTORY_ID = "o-1KB081-na1";
export const REACT_APP_NAME = "Growsari";
export const REACT_APP_MESSAGES_HISTORY_BASE_URL = "https://jw73garfs0.execute-api.ap-southeast-1.amazonaws.com/prd/";
export const REACT_APP_GROWCUBE_GQL_API = "https://7075bx5ho5.execute-api.ap-southeast-1.amazonaws.com/prd/graphql";
export const REACT_GOOGLE_ANALYTICS_MEASUREMENT_ID = "G-QZC5F3KDSY";
export const REACT_APP_LINK_FBM_BASE_URL = "https://chatbot.growsari.com/api";
export const REACT_APP_PAYMENTS_BASE_URL = "https://payments.growsari.com/payments/api/";
